import { useMemo, createContext, useCallback, useContext, useEffect } from 'react';
import { useAddRenderComponents } from '../../render/renderComponents/useAddRenderComponent';
import { useHandler } from '../../handlers/useHandler';
import { useAddIdsForBulkActions } from '../hooks/useAddIdsForBulkActions';
import { AsyncBulkActionsWrapper, loadBulkActionsWrapper } from './AsyncBulkActionsWrapper';
import { catchBoardError } from '../../error/utils';

// Create context for bulk actions
import { jsx as _jsx } from "react/jsx-runtime";
export const BulkActionsContext = /*#__PURE__*/createContext(undefined);

// Hook to use the context
export const useBulkActionsContext = () => {
  return useContext(BulkActionsContext);
};
export const BulkActionsProvider = ({
  children,
  hasBulkActions,
  isBulkActionsRedesignEnabled
}) => {
  const addRenderComponents = useAddRenderComponents();
  const addAllIds = useAddIdsForBulkActions();
  const handleDataReceived = useCallback(({
    ids
  }) => {
    addAllIds(ids);
  }, [addAllIds]);
  const handleCardMounted = useCallback(() => {
    if (hasBulkActions) {
      catchBoardError('loadBulkActionsWrapper', loadBulkActionsWrapper()).catch(() => {} //swallow
      );
    }
  }, [hasBulkActions]);
  useHandler('onDataReceived', handleDataReceived);
  useHandler('onCardMounted', handleCardMounted);
  useEffect(() => {
    if (!hasBulkActions) {
      return;
    }
    addRenderComponents([{
      key: 'renderBulkAction',
      renderComponent: AsyncBulkActionsWrapper
    }]);
  }, [addRenderComponents, hasBulkActions]);
  const contextValue = useMemo(() => {
    return {
      hasBulkActions: hasBulkActions || false,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled || false
    };
  }, [hasBulkActions, isBulkActionsRedesignEnabled]);
  return /*#__PURE__*/_jsx(BulkActionsContext.Provider, {
    value: contextValue,
    children: children
  });
};